import { FormControl, FormControlLabel, FormGroup, Switch as SwitchMaterial } from "@mui/material";

export const Switch = (props) => {
  const { id, label, labelTrue, labelPlacement = "end", value, onChange, ...rest } = props;

  const roles = {
    input: "switch-input",
    label: "switch-label",
  };

  return (
    <FormControl component="fieldset">
      <FormGroup aria-label="bbj-switch" row>
        <FormControlLabel
          control={<SwitchMaterial id={id} value={value} {...rest} onChange={onChange} role={roles.input} />}
          label={`${!value ? label : labelTrue || label}`}
          labelPlacement={labelPlacement}
          role={roles.label}
        />
      </FormGroup>
    </FormControl>
  );
};
